import { createSlice } from '@reduxjs/toolkit';

const initialTransactionState = {
    transaction: null,
}

export const TransactionSlices = createSlice({
    name: 'transactions',
    initialState: initialTransactionState,
    reducers: {
        transaction: (state, action) => {
            state.transaction = action.payload.transaction
        },
    },
})
